import { useState, useEffect, useCallback } from 'react';
import { getToken, removeToken, validateToken, isTokenExpired, setToken, setRefreshToken, sessionManager } from '../utils/auth';

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);

  const checkAuthStatus = useCallback(async () => {
    const token = getToken();
    
    if (!token) {
      setIsAuthenticated(false);
      setUser(null);
      setIsLoading(false);
      return;
    }

    // Check if token is expired locally first
    if (isTokenExpired(token)) {
      console.log('Token expired locally');
      handleLogout();
      return;
    }

    // Validate with server
    try {
      const isValid = await validateToken(token);
      if (isValid) {
        setIsAuthenticated(true);
        // You might want to fetch user data here
        setIsLoading(false);
      } else {
        handleLogout();
      }
    } catch (error) {
      console.error('Auth check failed:', error);
      handleLogout();
    }
  }, []);

  const handleLogout = useCallback(() => {
    removeToken();
    setIsAuthenticated(false);
    setUser(null);
    sessionManager.stopSessionCheck();
  }, []);

  const login = useCallback((token, refreshToken, userData) => {
    setToken(token);
    if (refreshToken) {
      setRefreshToken(refreshToken);
    }
    setIsAuthenticated(true);
    setUser(userData);
    sessionManager.startSessionCheck();
  }, []);

  useEffect(() => {
    checkAuthStatus();
    
    // Set up session manager
    sessionManager.setLogoutCallback(handleLogout);
    
    return () => {
      sessionManager.stopSessionCheck();
    };
  }, [checkAuthStatus, handleLogout]);

  return {
    isAuthenticated,
    isLoading,
    user,
    login,
    logout: handleLogout,
    checkAuthStatus
  };
};


